const responseHandler = async (response, reloadOnSuccess) =>
{	//2016-05-24
	reloadOnSuccess = (typeof(reloadOnSuccess) === 'undefined'?true:reloadOnSuccess);
	
	if(response.status < 0 || response.status >= 400)
	{
		// Fetch alerts lib
		const alerts = (await import('./alerts-promise.js')).default;

		await alerts.alert(response.message)
	}
	
	if(response.status >= 0 && response.status < 400)
	{
		if(typeof(response.successURL) === 'string' && response.successURL !== '')
		{
			window.location = response.successURL;
			
			return true;
		}
		
		if(reloadOnSuccess)
		{
			window.onbeforeunload = null;
			window.location.reload(true);
		}
		
		return true;
	}
	
	if(typeof(response.errorURL) === 'string' && response.errorURL !== '')
	{
		window.location = response.errorURL;
		
		return false;
	}
	
	if(typeof(response.field) === 'string')
	{
		/** @type {HTMLInputElement|null} */
		const field = document.querySelector('[name="'+response.field+'"]');
		
		if(field) field.focus();
	}
	
	return response.status >= 0;
};

export default responseHandler;
